import { jsx as e, jsxs as t, Fragment as a } from "react/jsx-runtime";
import { LegalFooter as c } from "@intergamma/legal-footer";
import { Container as d } from "@intergamma/container";
import { cn as o } from "@intergamma/common/cn";
function s({
  t: i
}) {
  return /* @__PURE__ */ e("div", { className: "bg-brand-primary px-4 pb-8 pt-4 leading-[28px] text-white", children: /* @__PURE__ */ t(d, { children: [
    /* @__PURE__ */ t("div", { className: "mb-1 flex items-center leading-[28px]", children: [
      /* @__PURE__ */ t(
        "svg",
        {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          className: "mr-2",
          children: [
            /* @__PURE__ */ e("g", { clipPath: "url(#clip0_33_2069)", children: /* @__PURE__ */ e(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 2C7.99594 2 4.75 5.24594 4.75 9.25V9.6875C4.75 9.70789 4.74919 9.7281 4.74759 9.74808C5.92335 10.2373 6.75 11.3971 6.75 12.75V14.75C6.75 16.5449 5.29493 18 3.5 18C1.70507 18 0.25 16.5449 0.25 14.75V12.75C0.25 11.0392 1.57189 9.63713 3.25 9.50947V9.25C3.25 4.41751 7.16751 0.5 12 0.5C16.8325 0.5 20.75 4.41751 20.75 9.25V9.50947C22.4281 9.63713 23.75 11.0392 23.75 12.75V14.75C23.75 16.5219 22.3321 17.9625 20.569 17.9993C19.9102 20.6751 17.5279 22.6729 14.6668 22.7478C14.2349 23.4963 13.4263 24 12.5 24H11.5C10.1193 24 9 22.8807 9 21.5C9 20.1193 10.1193 19 11.5 19H12.5C13.788 19 14.8484 19.974 14.9851 21.2255C16.9823 21.0229 18.6139 19.583 19.1012 17.6844C18.0064 17.1616 17.25 16.0441 17.25 14.75V12.75C17.25 11.398 18.0755 10.2389 19.25 9.74908V9.25C19.25 5.24594 16.0041 2 12 2ZM20.5 16.5C21.4665 16.5 22.25 15.7165 22.25 14.75V12.75C22.25 11.7835 21.4665 11 20.5 11C19.5335 11 18.75 11.7835 18.75 12.75V14.75C18.75 15.7165 19.5335 16.5 20.5 16.5ZM10.5 21.5C10.5 20.9477 10.9477 20.5 11.5 20.5H12.5C13.0523 20.5 13.5 20.9477 13.5 21.5C13.5 22.0523 13.0523 22.5 12.5 22.5H11.5C10.9477 22.5 10.5 22.0523 10.5 21.5ZM3.5 11C2.5335 11 1.75 11.7835 1.75 12.75V14.75C1.75 15.7165 2.5335 16.5 3.5 16.5C4.4665 16.5 5.25 15.7165 5.25 14.75V12.75C5.25 11.7835 4.4665 11 3.5 11Z",
                fill: "#FFFFFF"
              }
            ) }),
            /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_33_2069", children: /* @__PURE__ */ e("rect", { width: "24", height: "24", fill: "white" }) }) })
          ]
        }
      ),
      /* @__PURE__ */ e("h3", { className: "text-[26px] font-normal leading-[32px] gamma:font-tertiary gamma:uppercase karwei:font-extrabold", children: i("ig-footer:CustomerServiceTitle") })
    ] }),
    i("ig-footer:CustomerServiceDescription1"),
    " ",
    /* @__PURE__ */ e(
      "a",
      {
        className: "text-white underline hover:text-white hover:no-underline",
        href: i("ig-footer:CustomerServiceUrl1"),
        children: i("ig-footer:CustomerServiceLinkText1")
      }
    ),
    " ",
    i("ig-footer:CustomerServiceDescription2"),
    " ",
    /* @__PURE__ */ e(
      "a",
      {
        className: "text-white underline hover:text-white hover:no-underline",
        href: i("ig-footer:CustomerServiceUrl2"),
        children: i("ig-footer:CustomerServiceLinkText2")
      }
    ),
    " ",
    /* @__PURE__ */ e(
      "a",
      {
        className: "text-white underline hover:text-white hover:no-underline",
        href: i("ig-footer:CustomerServiceUrl3"),
        children: i("ig-footer:CustomerServiceLinkText3")
      }
    ),
    " ",
    i("ig-footer:andThe"),
    " ",
    /* @__PURE__ */ e(
      "a",
      {
        className: "text-white underline hover:text-white hover:no-underline",
        href: i("ig-footer:CustomerServiceUrl4"),
        children: i("ig-footer:CustomerServiceLinkText4")
      }
    ),
    "."
  ] }) });
}
function h({ formula: i }) {
  return i.brand === "karwei" ? /* @__PURE__ */ t(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("g", { clipPath: "url(#clip0_511_3151)", children: /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.42516 11.6755L5.60714 14.8575L1.86843 18.5962C0.696853 19.7678 0.696853 21.6673 1.86843 22.8389C3.04 24.0104 4.93949 24.0104 6.11107 22.8389L9.84978 19.1001L12.3247 21.575C13.1057 22.3561 14.372 22.3561 15.1531 21.575L22.7712 13.9569C23.5522 13.1758 23.5522 11.9095 22.7712 11.1285L12.8717 1.22898C12.0907 0.447927 10.8243 0.447926 10.0433 1.22898L2.42516 8.84709C1.64411 9.62814 1.64411 10.8945 2.42516 11.6755ZM7.02135 14.8575L3.13227 10.9684C2.74174 10.5779 2.74174 9.94472 3.13227 9.5542L10.7504 1.93608C11.1409 1.54556 11.7741 1.54556 12.1646 1.93608L15.7001 5.47162L12.853 8.31873L13.5601 9.02583L16.4072 6.17873L17.8214 7.59293L16.3902 9.02414L17.0973 9.73124L18.5286 8.30004L22.0641 11.8356C22.4546 12.2261 22.4546 12.8593 22.0641 13.2498L16.7961 18.5178L5.48236 7.2041L4.77395 7.91252L16.0877 19.2262L14.446 20.8679C14.0555 21.2584 13.4223 21.2584 13.0318 20.8679L9.84978 17.6859L5.40396 22.1317C4.62291 22.9128 3.35658 22.9128 2.57553 22.1317C1.79448 21.3507 1.79448 20.0844 2.57553 19.3033L7.02135 14.8575Z",
            fill: "black"
          }
        ) }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_511_3151", children: /* @__PURE__ */ e("rect", { width: "24", height: "24", fill: "white" }) }) })
      ]
    }
  ) : /* @__PURE__ */ t(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M4.74954 20.0001C5.16376 20.0001 5.49954 19.6643 5.49954 19.2501C5.49954 18.8359 5.16376 18.5001 4.74954 18.5001C4.33533 18.5001 3.99954 18.8359 3.99954 19.2501C3.99954 19.6643 4.33533 20.0001 4.74954 20.0001Z",
            fill: "#003878"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.244 0.794534C17.1202 0.484573 15.9377 0.449356 14.7993 0.699728C13.3877 1.01016 12.1116 1.74482 11.1415 2.80771C10.1714 3.87057 9.55517 5.20919 9.37242 6.64472C9.21328 7.89476 9.43553 8.98536 9.7474 9.97553L2.49735 16.3086C2.11025 16.6365 1.79708 17.0423 1.57739 17.5002C1.35676 17.96 1.23555 18.4617 1.22038 18.973C1.20521 19.4843 1.29637 19.9942 1.48703 20.4707C1.67767 20.9472 1.96387 21.3805 2.32733 21.7439C2.68993 22.1064 3.12222 22.392 3.59744 22.5825C4.07269 22.773 4.58123 22.8646 5.09134 22.8503C5.60151 22.836 6.10221 22.7162 6.56155 22.4973C7.01882 22.2794 7.42457 21.9683 7.75312 21.5835L14.1228 14.3562C15.1189 14.6804 16.3106 14.9722 17.6327 14.7816C19.1329 14.5654 20.5171 13.8755 21.5832 12.8095C22.5314 11.8619 23.1848 10.6599 23.4692 9.34381C23.692 8.31215 23.6809 7.24395 23.4426 6.21585C23.2089 5.20778 22.0202 5.04044 21.403 5.6576L18.6243 8.43634C18.5267 8.53397 18.3684 8.53397 18.2708 8.43634L15.8838 6.04944C15.7862 5.95181 15.7862 5.79352 15.8838 5.69588L18.7557 2.824C19.3617 2.21805 19.2152 1.06239 18.244 0.794534ZM15.1214 2.16472C15.8482 2.00489 16.6002 1.99232 17.3341 2.12432L14.8232 4.63522C14.1398 5.31864 14.1398 6.42668 14.8232 7.1101L17.2101 9.497C17.8935 10.1804 19.0015 10.1804 19.685 9.497L22.0805 7.10149C22.1649 7.74358 22.1395 8.39494 22.003 9.02705C21.7791 10.0633 21.2655 11.0064 20.5227 11.7486C19.6877 12.5836 18.6012 13.1266 17.4187 13.297C16.3866 13.4457 15.4161 13.2077 14.4459 12.8833C13.9729 12.7251 13.4428 12.8591 13.1053 13.2421L6.62366 20.5964L6.61497 20.6064C6.42294 20.8323 6.18521 21.015 5.91629 21.1432C5.64733 21.2713 5.3523 21.3424 5.04935 21.3509C4.74634 21.3594 4.44195 21.305 4.15559 21.1902C3.8692 21.0754 3.60766 20.9028 3.38785 20.6831C3.16753 20.4628 2.99458 20.2006 2.87969 19.9135C2.76481 19.6264 2.71071 19.3212 2.71972 19.0175C2.72872 18.7139 2.8006 18.4183 2.92978 18.1491C3.05894 17.8799 3.2429 17.6422 3.46997 17.4505L3.47963 17.4422L10.8556 10.9992C11.2424 10.6613 11.3753 10.1308 11.2213 9.65941C10.9177 8.73011 10.733 7.83527 10.8604 6.83416C11.0045 5.70236 11.4895 4.65146 12.2494 3.81891C13.0093 2.98638 14.0102 2.4091 15.1214 2.16472Z",
            fill: "#003878"
          }
        )
      ]
    }
  );
}
function C({ formula: i }) {
  return i.brand === "karwei" ? /* @__PURE__ */ e(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.618 5.32193C12.6648 4.19802 11.1699 3.66773 9.70721 3.9584L8.17531 4.26282C7.5489 4.3873 7.1411 3.62417 7.59269 3.17257L7.70855 3.05672C10.5013 0.263972 15.0292 0.263971 17.822 3.05672L19.1274 4.36217C19.4154 4.65014 19.4209 5.1153 19.1399 5.41002L18.5155 6.06464L19.2585 6.80758C19.5745 7.12359 20.0869 7.12359 20.4029 6.80758C20.7259 6.4845 21.2498 6.4845 21.5728 6.80758L23.0515 8.2862C23.442 8.67672 23.442 9.30988 23.0515 9.70041L19.773 12.9789C19.3824 13.3694 18.7493 13.3694 18.3587 12.9789L16.8955 11.5157C16.5639 11.1841 16.5639 10.6465 16.8955 10.3149C17.2455 9.96491 17.2455 9.39743 16.8955 9.04742L16.195 8.3469L14.5074 10.0345L5.73831 21.3628C5.37266 21.8351 4.67715 21.8837 4.24945 21.4667L0.516269 17.8269C0.0890428 17.4103 0.119318 16.7148 0.581124 16.3369L11.7016 7.23832L13.618 5.32193ZM22.3444 8.9933L19.0659 12.2718L17.7052 10.9111C18.3414 10.1661 18.3072 9.04492 17.6026 8.34031L16.9021 7.63979C16.5116 7.24927 15.8784 7.24927 15.4879 7.63979L14.1314 8.99629L12.7446 7.60951L14.5775 5.77662C14.7834 5.57077 14.8103 5.24627 14.641 5.00938C13.4794 3.38301 11.4726 2.58803 9.5123 2.97758L9.32073 3.01565C11.7137 1.39486 14.9953 1.64425 17.1149 3.76383L18.2476 4.89659L17.7919 5.37449C17.4171 5.76748 17.4244 6.38776 17.8084 6.77175L18.5514 7.51469C19.2167 8.18004 20.2714 8.21882 20.9821 7.63105L22.3444 8.9933ZM12.0039 8.28302L13.4664 9.74556L4.94755 20.7507L1.21436 17.1109L12.0039 8.28302Z",
          fill: "black"
        }
      )
    }
  ) : /* @__PURE__ */ t(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M4.25 6.75C4.25 6.33579 4.58579 6 5 6H11C11.4142 6 11.75 6.33579 11.75 6.75C11.75 7.16421 11.4142 7.5 11 7.5H5C4.58579 7.5 4.25 7.16421 4.25 6.75Z",
            fill: "#003878"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M4.25 9.25C4.25 8.83579 4.58579 8.5 5 8.5H11C11.4142 8.5 11.75 8.83579 11.75 9.25C11.75 9.66421 11.4142 10 11 10H5C4.58579 10 4.25 9.66421 4.25 9.25Z",
            fill: "#003878"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.25 5C0.25 3.48122 1.48122 2.25 3 2.25H16.2142C18.05 2.25 19.3569 4.00858 18.86 5.75H19.5C20.4665 5.75 21.25 6.5335 21.25 7.5V7.75H23.25C23.6642 7.75 24 8.08579 24 8.5C24 8.91421 23.6642 9.25 23.25 9.25H21.25V9.5C21.25 10.4665 20.4665 11.25 19.5 11.25H17.0072L16.7948 11.8794C16.4175 12.9973 15.3691 13.75 14.1892 13.75H11.2268L10.8844 16.8319C10.7631 17.9239 9.84008 18.75 8.74138 18.75C8.41044 18.75 8.13128 18.9964 8.09023 19.3248L7.8537 21.2171C7.74424 22.0928 6.99978 22.75 6.11722 22.75H4.12454C3.07701 22.75 2.26413 21.8359 2.38653 20.7955L3.21542 13.75H3C1.48122 13.75 0.25 12.5188 0.25 11V5ZM4.72576 13.75L3.87626 20.9708C3.85877 21.1194 3.9749 21.25 4.12454 21.25H6.11722C6.2433 21.25 6.34965 21.1561 6.36529 21.031L6.60182 19.1388C6.7367 18.0597 7.65395 17.25 8.74138 17.25C9.07575 17.25 9.35665 16.9986 9.39358 16.6663L9.71761 13.75H4.72576ZM19.5 9.75H17.5134L18.3572 7.25H19.5C19.6381 7.25 19.75 7.36193 19.75 7.5V9.5C19.75 9.63807 19.6381 9.75 19.5 9.75ZM3 3.75C2.30964 3.75 1.75 4.30964 1.75 5V11C1.75 11.6904 2.30964 12.25 3 12.25H14.1892C14.7255 12.25 15.202 11.9079 15.3735 11.3997L17.3985 5.39972C17.672 4.58946 17.0693 3.75 16.2142 3.75H3Z",
            fill: "#003878"
          }
        )
      ]
    }
  );
}
function p({
  formula: i,
  t: r
}) {
  return /* @__PURE__ */ e("div", { className: "bg-[rgb(240,242,246)] p-4 pb-8 text-brand-primary karwei:bg-neutral-100", children: /* @__PURE__ */ e(d, { children: /* @__PURE__ */ t("div", { className: "flex flex-row justify-between leading-[28px]", children: [
    /* @__PURE__ */ t("div", { className: "flex-nowrap gap-4 pr-4", children: [
      /* @__PURE__ */ t("div", { className: "flex", children: [
        i.id !== "gamma_be" ? /* @__PURE__ */ e(h, { formula: i }) : /* @__PURE__ */ e(C, { formula: i }),
        /* @__PURE__ */ e("h3", { className: "ml-2 pr-4 text-[18px] leading-[24px] gamma:font-tertiary gamma:uppercase karwei:font-extrabold", children: i.brand === "karwei" ? r("ig-footer:DiyTitleKarwei") : r("ig-footer:DiyTitle") })
      ] }),
      /* @__PURE__ */ e("div", { className: "ml-8", children: i.brand === "karwei" ? /* @__PURE__ */ t(a, { children: [
        r("ig-footer:DiyDescriptionKarwei1"),
        " ",
        /* @__PURE__ */ e(
          "a",
          {
            className: "underline hover:no-underline",
            href: r("ig-footer:DiyUrl"),
            children: r("ig-footer:DiyLinkText")
          }
        ),
        " ",
        "en",
        " ",
        /* @__PURE__ */ e(
          "a",
          {
            className: "underline hover:no-underline",
            href: "/wooninspiratie",
            children: r("ig-footer:DiyLinkTextKarwei")
          }
        ),
        " ",
        r("ig-footer:DiyDescriptionKarwei2")
      ] }) : /* @__PURE__ */ t(a, { children: [
        r("ig-footer:DiyDescription"),
        " ",
        /* @__PURE__ */ e(
          "a",
          {
            className: "underline hover:no-underline",
            href: r("ig-footer:DiyUrl"),
            children: r("ig-footer:DiyLinkText")
          }
        )
      ] }) })
    ] }),
    i.id !== "gamma_be" && /* @__PURE__ */ t("div", { className: "flex-nowrap gap-6", children: [
      /* @__PURE__ */ t("div", { className: "flex", children: [
        /* @__PURE__ */ e(C, { formula: i }),
        /* @__PURE__ */ e("h3", { className: "ml-2 pr-4 text-[18px] leading-[24px] gamma:font-tertiary gamma:uppercase karwei:font-extrabold", children: i.brand === "karwei" ? r("ig-footer:HelpTitleKarwei") : r("ig-footer:HelpTitle") })
      ] }),
      /* @__PURE__ */ t("div", { className: "ml-8", children: [
        r("ig-footer:HelpDescription"),
        " ",
        /* @__PURE__ */ e(
          "a",
          {
            className: "underline hover:no-underline",
            href: r("ig-footer:HelpUrl"),
            children: r("ig-footer:HelpLinkText", { brand: i.brandName })
          }
        )
      ] })
    ] })
  ] }) }) });
}
function f({ className: i }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      className: i,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5 15.4053L6.96967 9.875C6.67678 9.58211 6.67678 9.10724 6.96967 8.81434C7.26256 8.52145 7.73744 8.52145 8.03033 8.81434L12.5 13.284L16.9697 8.81434C17.2626 8.52145 17.7374 8.52145 18.0303 8.81434C18.3232 9.10724 18.3232 9.58211 18.0303 9.875L12.5 15.4053Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.5",
          strokeLinecap: "round"
        }
      )
    }
  );
}
function l({
  title: i,
  links: r
}) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: o(
        "w-full border-t border-white py-2 last-of-type:border-b",
        "md:border-t-0 md:px-2 md:py-0 md:last-of-type:border-b-0",
        "lg:max-w-[25%] lg:px-2.5"
      ),
      children: [
        /* @__PURE__ */ t(
          "label",
          {
            className: o(
              "group peer flex w-full font-tertiary karwei:font-primary karwei:font-extrabold karwei:capitalize",
              "items-center justify-between text-[18px] uppercase"
            ),
            children: [
              i,
              /* @__PURE__ */ e(f, { className: "inline-block duration-500 ease-in-out group-has-[:checked]:rotate-180 md:hidden" }),
              /* @__PURE__ */ e("input", { type: "checkbox", className: "hidden" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: o(
              "grid overflow-hidden duration-500 ease-in-out md:transition-none",
              " grid-rows-[0fr] peer-has-[:checked]:grid-rows-[1fr] peer-has-[:checked]:pt-2",
              " md:grid-rows-[auto] md:p-0"
            ),
            children: /* @__PURE__ */ e("ul", { className: "list-none overflow-hidden", children: r.map((n) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ e(
              "a",
              {
                href: n.url,
                className: "text-white no-underline hover:text-white hover:underline",
                children: n.title
              }
            ) }, n.title)) })
          }
        )
      ]
    }
  );
}
function g({
  formula: i,
  t: r
}) {
  return /* @__PURE__ */ e("div", { className: "karwei:[#111316] bg-brand-primary p-4 pb-8 text-white", children: /* @__PURE__ */ e(d, { children: /* @__PURE__ */ t("div", { className: "-mx-2.5 flex flex-col px-4 leading-[28px] md:flex-row md:p-0", children: [
    /* @__PURE__ */ e(
      l,
      {
        title: r("ig-footer:Assortment"),
        links: r("ig-footer:AssortmentLinks", {
          returnObjects: !0,
          context: i.brand
        })
      }
    ),
    /* @__PURE__ */ e(
      l,
      {
        title: r("ig-footer:DiyAdvice"),
        links: r("ig-footer:DiyAdviceLinks", {
          returnObjects: !0,
          context: i.brand
        })
      }
    ),
    /* @__PURE__ */ e(
      l,
      {
        title: r("ig-footer:Services"),
        links: r("ig-footer:ServicesLinks", {
          returnObjects: !0,
          context: i.brand
        })
      }
    ),
    /* @__PURE__ */ e(
      l,
      {
        title: i.brandName,
        links: r("ig-footer:AboutLinks", {
          returnObjects: !0,
          context: i.brand
        })
      }
    )
  ] }) }) });
}
function v({
  formula: i,
  t: r,
  lang: n
}) {
  return /* @__PURE__ */ t("footer", { className: "leading-6 antialiased [text-rendering:optimizeLegibility]", children: [
    /* @__PURE__ */ e(p, { formula: i, t: r }),
    /* @__PURE__ */ e(s, { t: r }),
    /* @__PURE__ */ e(g, { formula: i, t: r }),
    /* @__PURE__ */ e(c, { formula: i, t: r, lang: n })
  ] });
}
export {
  v as Footer
};
